import "../css/Sidebar.css";
// import { getAllStudents } from "./models/apiCall";
export default function Sidebar() {
  let dashBoardColor = "";
  let rekapColor = "";
  let visualiasiColor = "";
  const currentUrl = window.location.href;
  const segments = currentUrl.split("/");
  const page = segments[segments.length - 1];

  if (page === "rekap") {
    rekapColor = "#1D6146";
    dashBoardColor = "#6C737F";
    visualiasiColor = "#6C737F";
  } else if (page === "visualisasi") {
    visualiasiColor = "#1D6146";
    rekapColor = "#6C737F";
    dashBoardColor = "#6C737F";
  } else if (page === "") {
    dashBoardColor = "#1D6146";
    rekapColor = "#6C737F";
    visualiasiColor = "#6C737F";
  }

  return (
    <>
      <ul
        className="navbar-nav bg-kntl sidebar sidebar-dark accordion mt-0"
        id="accordionSidebar"
        style={{ height: "100vh" }}
      >
        <li className="nav-item active">
          <a className="nav-link collapsed d-flex align-items-center" href="/">
            {page === "" ? <span className="select-bar"></span> : <></>}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill={dashBoardColor}
              className="bi bi-grid-fill mx-2"
              viewBox="0 0 16 16"
            >
              <path d="M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5zm8 0A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5zm-8 8A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5zm8 0A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5z" />
            </svg>
            <span
              className="manrope-normal-inactive"
              style={{ color: dashBoardColor }}
            >
              Dashboard
            </span>
          </a>
        </li>
        <li className="nav-item active">
          <a
            className="nav-link collapsed d-flex align-items-center"
            href="/rekap"
          >
            {page === "rekap" ? <span className="select-bar"></span> : <></>}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill={rekapColor}
              className="bi bi-archive-fill mx-2"
              viewBox="0 0 16 16"
            >
              <path d="M12.643 15C13.979 15 15 13.845 15 12.5V5H1v7.5C1 13.845 2.021 15 3.357 15zM5.5 7h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1M.8 1a.8.8 0 0 0-.8.8V3a.8.8 0 0 0 .8.8h14.4A.8.8 0 0 0 16 3V1.8a.8.8 0 0 0-.8-.8z" />
            </svg>
            <span
              className="manrope-normal-inactive"
              style={{ color: rekapColor }}
            >
              Rekap Antrian
            </span>
          </a>
        </li>
        <li className="nav-item active">
          <a
            className="nav-link collapsed d-flex align-items-center"
            href="/visualisasi"
          >
            {page === "visualisasi" ? (
              <span className="select-bar"></span>
            ) : (
              <></>
            )}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill={visualiasiColor}
              className="bi bi-archive-fill mx-2"
              viewBox="0 0 16 16"
            >
              <path d="M12.643 15C13.979 15 15 13.845 15 12.5V5H1v7.5C1 13.845 2.021 15 3.357 15zM5.5 7h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1M.8 1a.8.8 0 0 0-.8.8V3a.8.8 0 0 0 .8.8h14.4A.8.8 0 0 0 16 3V1.8a.8.8 0 0 0-.8-.8z" />
            </svg>
            <span
              className="manrope-normal-inactive"
              style={{ color: visualiasiColor }}
            >
              Visualisasi Data
            </span>
          </a>
        </li>
      </ul>
    </>
  );
}
